import { reduxActions, requestStatus } from '../constants';

const defaultFetchState = {
    progress: requestStatus.INACTIVE,
    message: '',
    fetchtype: ''
}

export function fetchState(state = defaultFetchState, action) {
    switch (action.type) {
        case reduxActions.RESOURCE_FETCH:
        case reduxActions.RESOURCE_FETCH_FAIL:
        case reduxActions.RESOURCE_FETCH_SUCCESS:
            return {
                progress: action.progress,
                fetchType: action.fetchType || '',
                error: action.error,
                message: action.message,
                payload: action.payload,
                request: action.request
            }
        case reduxActions.RESOURCE_RESET:
            return defaultFetchState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/resource-reducer.js